(function () {
  function fix() {
    document.querySelectorAll('input.wt-newsletter__field').forEach(function (input) {
      if (!input.getAttribute('aria-label') && !(input.labels && input.labels.length)) {
        input.setAttribute('aria-label', 'Email address');
      }
      if (!input.getAttribute('autocomplete')) {
        input.setAttribute('autocomplete', 'email');
      }
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fix);
  } else {
    fix();
  }
})();
